<template>
  <div class="recyclertAddEdit">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="绑定用户" prop="wlUserId">
        <el-select
          :disabled="isQuery"
          v-model="ruleForm.wlUserId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="wlUserIdchange"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input :readonly="isQuery" v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input :readonly="isQuery" v-model="ruleForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="街道" prop="street">
        <el-select
          :disabled="isQuery"
          v-model="ruleForm.street"
          @change="streetchange"
          multiple
          placeholder="请选择街道"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, key) in streetList"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="社区" prop="communityIds">
        <el-select
          :disabled="ruleForm.street.length == 0 || isQuery"
          v-model="ruleForm.communityIds"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethodcommunity"
        >
          <el-option
            v-for="item in communityList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系地址" prop="address">
        <el-input :readonly="isQuery" v-model="ruleForm.address"></el-input>
      </el-form-item>
      <el-form-item label="是否通过" prop="status">
        <el-select
          :disabled="isQuery"
          v-model="ruleForm.status"
          placeholder="请选择是否通过"
        >
          <el-option label="通过" value="0"></el-option>
          <el-option label="不通过" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色" prop="roles">
        <el-checkbox-group v-model="ruleForm.roles">
          <el-checkbox
            :disabled="isQuery"
            :label="item.id"
            :name="item.id"
            v-for="(item, key) in ruleList"
            :key="key"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="头像" prop="avatar">
        <img
          style="width: 100px; height: 100px"
          v-if="ruleForm.avatar"
          v-show="isQuery"
          :src="ruleForm.avatar"
          class="avatar"
        />
        <el-upload
          v-show="!isQuery"
          class="avatar-uploader"
          action="#"
          :before-upload="beforeAvatarUpload"
          accept="image/jpeg,image/gif,image/png,image/bmp"
        >
          <img
            style="width: 100px; height: 100px"
            v-if="ruleForm.avatar"
            :src="ruleForm.avatar"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item v-if="!isQuery">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { publicMixin } from "@/mixins/publicMixin";
import {
  frontUserlist,
  addressstreetlist,
  addresscommunitylist,
  frontUserrolelist,
  frontUsercheckUserBind,
} from "@/api/management";
export default {
  name: "recyclertAddEdit",
  props: ["isWhat", "recycleData", "isQuery"],
  mixins: [publicMixin],
  data() {
    return {
      ruleList: [],
      wlStreetId: [],
      name: "",
      options: [],
      value: [],
      loading: false,
      streetList: [],
      communityList: [],
      ruleForm: {
        wlUserId: "",
        name: "",
        phone: "",
        street: [],
        communityIds: [],
        address: "",
        status: "",
        roles: [],
        avatar: "",
        id: "",
      },
      rules: {
        wlUserId: [
          { required: true, message: "请绑定用户", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号不正确", trigger: "blur" },
        ],
        street: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个街道",
            trigger: "change",
          },
        ],
        communityIds: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个社区",
            trigger: "change",
          },
        ],
        address: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择是否通过", trigger: "change" },
        ],
        roles: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个角色",
            trigger: "change",
          },
        ],
        avatar: [{ required: true, message: "请上传头像", trigger: "blur" }],
      },
    };
  },
  watch: {
    recycleData(val) {
      console.log(val);
      if (val) {
        this.ruleForm.street = [];
        this.ruleForm.communityIds = [];
        this.ruleForm.roles = [];
        val.streetList.forEach((item) => {
          this.ruleForm.street.push(item.id);
        });
        this.getaddresscommunitylist("", this.ruleForm.street);
        val.communityList.forEach((item) => {
          this.ruleForm.communityIds.push(item.id);
        });
        val.roles.forEach((item) => {
          this.ruleForm.roles.push(item.roleId);
        });
        this.ruleForm.wlUserId = val.wlUserId;
        this.ruleForm.name = val.name;
        this.ruleForm.phone = val.phone;
        this.ruleForm.address = val.address;
        this.ruleForm.status = String(val.status);
        this.ruleForm.avatar = val.avatar;
        this.ruleForm.id = val.id;
        let obj = [
          {
            id: val.wlUserId,
            nickname: val.wlUserName,
          },
        ];
        this.options = obj;
      }
    },
  },
  computed: {},
  methods: {
    wlUserIdchange(val) {
      console.log(val);
      frontUsercheckUserBind({
        busiUserId: this.ruleForm.id || "",
        cate: "1",
        wlUserId: val,
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            console.log("验证通过");
          } else {
            console.log("验证未通过");
            this.$message.error("此用户不可被绑定");
            this.ruleForm.wlUserId = "";
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getfrontUserrolelist() {
      frontUserrolelist({
        cate: "1",
      }).then((res) => {
        if (res.code == 200) {
          this.ruleList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getaddresscommunitylist(name, wlStreetId) {
      console.log(name, wlStreetId);
      if (wlStreetId != 0) {
        addresscommunitylist({
          name: name,
          wlStreetId: wlStreetId,
        }).then((res) => {
          if (res.code == 200) {
            this.communityList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    remoteMethodcommunity(query) {
      this.name = query;
      this.getaddresscommunitylist(this.name, this.wlStreetId);
    },
    streetchange(val) {
      this.ruleForm.communityIds = [];
      this.wlStreetId = val;
      this.getaddresscommunitylist(this.name, this.wlStreetId);
    },
    getaddressstreetlist() {
      addressstreetlist({}).then((res) => {
        if (res.code == 200) {
          this.streetList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    remoteMethod(query) {
      this.loading = true;
      if (query) {
        frontUserlist({ name: query }).then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.options = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.options = [];
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    beforeAvatarUpload(file) {
      this.uploadFile(file).then((res) => {
        this.ruleForm.avatar = res;
      });
      return false;
    },
  },
  created() {
    // this.getfrontUserlist();
    this.getaddressstreetlist();
    this.getfrontUserrolelist();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #666;
}
::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #000;
  cursor: not-allowed;
}
.recyclertAddEdit {
  padding: 0px 24px 24px 24px;
  ::v-deep .el-select {
    width: 100%;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
